import React from "react";
import styled from "styled-components";

const Bold = styled.span`
  font-weight: 700;
`;

function TextWithLineBreaks(props) {
  // Check if props.text is a string
  if (typeof props.text !== "string") {
    return null;
  }

  // Function to parse bold tags within a text segment
  const parseBoldText = (text, lineIndex) => {
    const parts = [];
    const regex = /\{b\}(.*?)\{\/b\}/g;
    let lastIndex = 0;
    let match;
    let partIndex = 0;

    while ((match = regex.exec(text)) !== null) {
      // Add text before the bold tag
      if (match.index > lastIndex) {
        parts.push(
          <React.Fragment key={`line-${lineIndex}-part-${partIndex++}`}>
            {text.substring(lastIndex, match.index)}
          </React.Fragment>
        );
      }
      // Add bold text
      parts.push(
        <Bold key={`line-${lineIndex}-bold-${partIndex++}`}>{match[1]}</Bold>
      );
      lastIndex = regex.lastIndex;
    }

    // Add remaining text after the last bold tag
    if (lastIndex < text.length) {
      parts.push(
        <React.Fragment key={`line-${lineIndex}-part-${partIndex++}`}>
          {text.substring(lastIndex)}
        </React.Fragment>
      );
    }

    return parts.length > 0 ? parts : text;
  };

  // Process the string with line breaks and bold tags
  const textWithBreaks = props.text.split("\n").map((text, index, array) => (
    <React.Fragment key={index}>
      {parseBoldText(text, index)}
      {index < array.length - 1 && <br />}
    </React.Fragment>
  ));

  return <>{textWithBreaks}</>;
}

export default TextWithLineBreaks;
